module.exports = __webpack_public_path__ + "img/grouping2.png";